<app-header></app-header>

<!-- ========== MAIN CONTENT ========== -->
<div id="join_call_screen" role="main" class="main">
  <!-- Content -->
  <div class="container-fluid p-0">
    <div class="row">
      <div class="col">
        <div class="join_call_wrapper">
          <ng-container [ngTemplateOutlet]="displayTemplate"></ng-container>

          <!-- <div class="powered_by text-center mt-6">
            <p>
              Powered by
              <img
                class="img-fluid w-10 ms-2"
                src="assets/images/powered_by.svg"
                alt="Powered by logo"
              />
            </p>
          </div> -->
        </div>
      </div>
    </div>
  </div>
  <!-- END Content -->
</div>

<ng-template #joinCall>
  <!-- Join Video/Audio Call -->
  <div class="join_call text-center">
    <h2 class="fw-normal mb-3">You are invited to join a video call</h2>
    <form [formGroup]="joincallform" (ngSubmit)="onSubmit(joincallform)">
      <div class="formgroup">
        <input
          type="text"
          formControlName="username"
          class="form-control form-control-lg"
          placeholder="Enter your name"
          name="username"
          tabindex="1"
          autocomplete="off"
        />

        <!-- Login Username error -->
        <div id="userName-error" class="invalid-feedback help-block">
          <div *ngIf="joinFC['username'].touched || joinFC['username'].dirty">
            <ng-container
              *ngIf="
                joinFC['username'].value === '' ||
                  joinFC['username'].value === null;
                else fnInvalid
              "
            >
              User name can't be empty.
            </ng-container>

            <ng-template #fnInvalid>
              <span *ngIf="joinFC['username'].errors">
                Please enter a valid user name.
              </span>
            </ng-template>
          </div>
        </div>
        <!-- End Login Username error -->
      </div>

      <!-- Audio/Video Options -->
      <div class="audio_video_options">
        <!-- Audio Mic -->
        <div
          class="audio btn btn-icon rounded"
          [ngClass]="micenabled ? 'btn-light' : 'btn-dark'"
          (click)="micenabled = !micenabled"
        >
          <em
            class="bi"
            [ngClass]="micenabled ? 'bi-mic-fill' : 'bi-mic-mute-fill'"
          ></em>
        </div>
        <!-- END Audio Mic -->

        <!-- Video Option -->
        <div
          class="video btn btn-icon rounded"
          [ngClass]="videoenabled ? 'btn-light' : 'btn-dark'"
          (click)="videoenabled = !videoenabled"
        >
          <em
            class="bi"
            [ngClass]="
              videoenabled ? 'bi-camera-video-fill' : 'bi-camera-video-off-fill'
            "
          ></em>
        </div>
        <!-- END Video Option -->
      </div>
      <!-- Audio/Video Options -->

      <!-- Button options -->
      <div
        class="join_btn_options d-flex align-items-center justify-content-center gap-2"
      >
        <!-- No Button -->
        <button class="btn btn-outline-light w-100" type="button">
          Cancel
        </button>
        <!-- END No Button -->

        <!-- Join Button -->
        <button
          class="btn btn-primary w-100"
          type="submit"
          [disabled]="joincallform.invalid"
        >
          Join
        </button>
        <!-- END Join Button -->
      </div>
      <!-- END Button options -->
    </form>
  </div>
  <!-- END Join Video/Audio Call -->
</ng-template>
